module.exports = __webpack_public_path__ + "img/airwallex-b.7c82b9e2.png";